import React, { Component, Fragment } from 'react';
import '../App.css';
import Section1 from './section1';
import Section2 from './section2';
import { fetchChuckNorrisJokes } from './home.service'




class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      joke: ""
    };
  }

  componentDidMount(){

    fetchChuckNorrisJokes().then((data) => {
        this.setState({
          joke : data.value
        });
        console.log(data.value);
      });

   
  }
  
  render() {
    return (
      <Fragment>
        {/* <Section1/> */}
        <Section2/>
      </Fragment>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/component/home/home.js